function findTable(textContent) {
    let tableText = createTableRows(textContent);
    let fieldsIndex = getFieldsIndex(tableText)
    let globalResult = [];
    for (let record of tableText) {
        let resultRecord = {
            name: '',
            quantity: 1,
            NETTO: 0,
            VAT: { percent: 0, value: 0 },
            BRUTTO: 0
        }
        if (fieldsIndex) {
            resultRecord.name = record.splice(fieldsIndex.name, 1)[0]
            resultRecord.quantity = parseInt(record.splice(fieldsIndex.quantity - 1, 1)[0]) || 1
        }
        let VAT = getVatByPercentAndValue(record, 23);
        if (VAT) {
            resultRecord.VAT.percent = VAT.percent;
            record.splice(VAT.index, 1);
            if (selectionOfNumbers(record, resultRecord)) {
                if (resultRecord.name == '') resultRecord.name = getNameField(record)
                globalResult.push(resultRecord);
                continue;
            } else {
                // console.log('selectionResult not finding ', record, resultRecord);
            }
        } else {
            // console.log('VAT not finding', record);
        }
    }
    let sumNetto = (globalResult.reduce((acc, curr, index) => index != globalResult.length - 1 ? acc + curr.NETTO : acc, 0)).toFixed(2);
    let sumBrutto = (globalResult.reduce((acc, curr, index) => index != globalResult.length - 1 ? acc + curr.BRUTTO : acc, 0)).toFixed(2);
    // console.log(123123123, { sumNetto, sumBrutto, 'globalResult': globalResult[globalResult.length - 1] });
    if (globalResult.length && (sumNetto == globalResult[globalResult.length - 1].NETTO || sumBrutto == globalResult[globalResult.length - 1].BRUTTO)) {
        globalResult.pop();
    }
    return globalResult;
}

function createTableRows(textContent) {
    textContent.items.sort((a, b) => {
            if (a.transform[5] == b.transform[5]) {
                return a.transform[4] - b.transform[4]
            }
            return b.transform[5] - a.transform[5]
        })
        //FIXME Если в поле названия больше двух строк текста
    textContent.items = textContent.items.filter(x => x.str != ' ' && x.str != '')
    let text = [
        []
    ];
    if (textContent.items.length > 0) {
        let currentY = textContent.items[0].transform[5];
        let numberStr = 1;
        let currentX = textContent.items[0].transform[4];
        // let currentWidth = textContent.items[0].width;

        for (let item of textContent.items) {
            if (
                item.transform[5] - 1.5 - item.height * numberStr <=
                currentY &&
                item.transform[5] + 1.5 + item.height * numberStr >=
                currentY
            ) {
                if (
                    item.transform[4] + 10 >= currentX &&
                    item.transform[4] - 10 <= currentX
                ) {
                    text[text.length - 1][
                        text[text.length - 1]["length"] - 1
                    ] += " " + item.str;
                    numberStr++;
                } else {
                    text[text.length - 1].push(
                        item.str
                        .replace(",", ".")
                        .trim()
                        .replace(/(?<=\d) (?=\d)/g, "")
                    );
                    numberStr = 1;
                }
                currentX = item.transform[4];
                // currentWidth = item.width;
            } else {
                currentY = item.transform[5];
                // currentWidth = item.width;
                numberStr = 1;
                currentX = item.transform[4];
                if (text[text.length - 1].length != 0) {
                    text.push([
                        item.str
                        .replace(",", ".")
                        .trim()
                        .replace(/(?<=\d) (?=\d)/g, ""),
                    ]);
                }
            }
        }
        for (let i in text) {
            for (let j in text[i]) {
                let vat = text[i][j].match(/\d{1,2}%/)
                if (vat) {
                    text[i][j] = vat[0]
                } else {
                    text[i][j] = text[i][j].replace(/(?<=\d)\s+(?=\d)/g, "")
                }

            }
        }
    }
    return text;

}
// NOTE Поиск VAT по знаку процента или по частому значению 23
function getVatByPercentAndValue(record, checkVat) {
    let index = record.findIndex(x => x.includes('%'));
    if (index != -1) {
        let reg = /(\d+(\.\d+)?)%/;
        let res = record[index].match(reg);
        if (res) return { percent: parseFloat(res[1]), index }
    }
    index = record.findIndex(x => x == checkVat);
    if (index != -1) return { percent: +record[index], index }
    return false
}
//NOTE Подбор чисел
function selectionOfNumbers(record, resultRecord) {
    let numbers = record.filter(x => x[x.length - 1] != '.' && !x.match(/\d ?- ?\d/)).map(x => {
        if (x.length < 20) {
            let num = x.match(/-?\d+[.,]?\d{0,2}/)
            return num && parseFloat(num[0])
        }
        return 0
    }).filter(Boolean);
    numbers.sort((a, b) => a - b)
    if (numbers.findIndex(x => x < 0) != -1) {
        numbers.reverse();
    }
    resultRecord.BRUTTO = numbers.pop();
    if (numbers[numbers.length - 1] == resultRecord.BRUTTO) numbers.splice(-1, 1);
    //FIXME Если мы уже занем VAT и BRUTTO то можно просто найти в массиве и NETTO по value VAT, вместо подставки последнего числа
    let checkNetto = checkNettoByVat(resultRecord.VAT.percent, numbers[numbers.length - 1], resultRecord.BRUTTO);
    if (checkNetto) {
        resultRecord.VAT.value = checkNetto.vatValue;
        resultRecord.NETTO = checkNetto.netto;
        // console.log('selectionOfNumbers 1');
    } else if (numbers.length == 2) {
        let NETTO = numbers.reduce((accum, curr) => accum * curr);
        checkNetto = checkNettoByVat(resultRecord.VAT.percent, NETTO, resultRecord.BRUTTO);
        // console.log('selectionOfNumbers 2', checkNetto, NETTO, resultRecord);
        if (checkNetto) {
            resultRecord.VAT.value = checkNetto.vatValue;
        } else if (resultRecord.BRUTTO == NETTO) {
            resultRecord.NETTO = +((resultRecord.BRUTTO / (resultRecord.VAT.percent + 100)) * 100).toFixed(2)
            resultRecord.VAT.value = +(resultRecord.BRUTTO - resultRecord.NETTO).toFixed(2)
        } else {
            resultRecord.NETTO = NETTO;
        }
    } else if (numbers[numbers.length - 1] == resultRecord.BRUTTO) {
        // console.log('selectionOfNumbers 3');
        resultRecord.NETTO = numbers[numbers.length - 1]
    }
    if (resultRecord.quantity > 1 && resultRecord.NETTO) {
        resultRecord.NETTO = +(resultRecord.NETTO / resultRecord.quantity).toFixed(2)
    }

    return !!resultRecord.NETTO;
}

function getFieldsIndex(tabelArray) {
    for (let record of tabelArray) {
        let name = record.findIndex(x => x.match(/nazwa/i))
        let quantity = record.findIndex(x => x.match(/ilosc|ilość/i))
        if (name != -1 && quantity != -1) return { name, quantity }
    }
    return false
}

function getNameField(record) {
    for (let item of record) {
        if (item.replace(/[\d\s.]/g, '').length) {
            return item
        }
    }
    return ' '
}
//NOTE Проверка на правильность подбора чисел
function checkNettoByVat(vatPercent, netto, brutto) {
    let vatValue = +(netto * (vatPercent / 100)).toFixed(2);
    // console.log('checkNettoByVat', netto, vatValue, brutto);
    let sum = +(vatValue + netto).toFixed(2);
    if (sum == brutto || sum - 0.01 == brutto || sum + 0.01 == brutto) {
        return { vatValue, netto }
    }
    return false;
}

export { findTable }